/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Credit Card',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1 15.5C16.1 15.8314 15.8314 16.1 15.5 16.1H15C14.6686 16.1 14.4 15.8314 14.4 15.5C14.4 15.1686 14.6686 14.9 15 14.9H15.5C15.8314 14.9 16.1 15.1686 16.1 15.5ZM19.1 15.5C19.1 15.8314 18.8314 16.1 18.5 16.1H18C17.6686 16.1 17.4 15.8314 17.4 15.5C17.4 15.1686 17.6686 14.9 18 14.9H18.5C18.8314 14.9 19.1 15.1686 19.1 15.5ZM3.2 9.025H20.8V7C20.8 6.55817 20.4418 6.2 20 6.2H4C3.55817 6.2 3.2 6.55817 3.2 7V9.025ZM3.2 10.225H20.8V17C20.8 17.4418 20.4418 17.8 20 17.8H4C3.55817 17.8 3.2 17.4418 3.2 17V10.225ZM2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
